export const contents = [
  {
    id: "1",
    title: "星际回响",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20poster%20of%20a%20lone%20astronaut%20drifting%20before%20a%20colossal%20glowing%20planet%2C%20deep%20navy%20and%20orange%20color%20palette%2C%20dramatic%20rim%20light%2C%20clean%20minimal%20dark%20gradient%20background%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=mv-01&orientation=portrait",
    genres: ["科幻", "动作"],
    region: "美国",
    year: 2026,
    subtitle: "中文字幕",
    quality: "蓝光",
    duration: "142分钟",
    episodes: 0,
    rating: 8.9,
    hot: 986000,
    updatedAt: "2026-10-13",
    description: "一支深空探索小队在返航途中接收到一段来自未知星域的重复信号。为了查明信号来源，他们偏离既定航线，进入一片被废弃的空间站群。随着调查深入，队员们逐渐发现，这段回响或许与他们自己有着千丝万缕的联系。影片以宏大的宇宙景观与克制的叙事，探讨记忆、孤独与归途。"
  },
  {
    id: "2",
    title: "长安夜行",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20costume%20drama%20poster%20of%20a%20swordsman%20in%20dark%20robe%20walking%20through%20misty%20lantern-lit%20alley%20at%20night%2C%20deep%20navy%20and%20amber%20tones%2C%20clean%20minimal%20gradient%20background%2C%20dramatic%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=mv-02&orientation=portrait",
    genres: ["古装", "悬疑"],
    region: "中国大陆",
    year: 2025,
    subtitle: "中文字幕",
    quality: "超清",
    duration: "128分钟",
    episodes: 0,
    rating: 8.4,
    hot: 872000,
    updatedAt: "2026-10-11",
    description: "盛唐长安，一名身负旧案的游侠在夜色中被卷入一桩离奇命案。线索指向城中权贵的秘密集会，而真相层层叠叠，牵出多年前的一桩冤屈。刀光剑影之间，他必须在复仇与正义之间做出抉择。"
  },
  {
    id: "3",
    title: "深海迷航",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20deep%20sea%20adventure%20poster%20of%20a%20small%20submarine%20descending%20into%20glowing%20dark%20ocean%20trench%2C%20deep%20blue%20and%20teal%20palette%20with%20orange%20light%20accents%2C%20clean%20minimal%20gradient%20background%2C%20dramatic%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=mv-03&orientation=portrait",
    genres: ["冒险", "科幻"],
    region: "中国大陆",
    year: 2026,
    subtitle: "中英字幕",
    quality: "蓝光",
    duration: "135分钟",
    episodes: 0,
    rating: 8.1,
    hot: 754000,
    updatedAt: "2026-10-12",
    description: "一次深海科考任务中，潜水器在万米海沟失去联系。救援小队深入黑暗的海底世界，面对未知生物与极端环境。当氧气与时间同时流逝，他们必须在绝境中寻回彼此，也寻回对未知的敬畏。"
  },
  {
    id: "4",
    title: "风起江南",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20drama%20poster%20of%20a%20couple%20standing%20near%20a%20misty%20Jiangnan%20water%20town%20bridge%20at%20dawn%2C%20soft%20blue%20and%20warm%20orange%20tones%2C%20clean%20minimal%20gradient%20background%2C%20gentle%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=mv-04&orientation=portrait",
    genres: ["爱情", "剧情"],
    region: "中国大陆",
    year: 2025,
    subtitle: "中文字幕",
    quality: "高清",
    duration: "118分钟",
    episodes: 0,
    rating: 7.8,
    hot: 512000,
    updatedAt: "2026-10-09",
    description: "江南水乡的清晨，两个追寻梦想的年轻人在桥头相遇。一个想离开小镇奔赴远方，一个想留下来守护家园。多年后重逢，他们才发现，当年那阵风早已改变了彼此的人生轨迹。"
  },
  {
    id: "5",
    title: "迷城追凶",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20poster%20of%20a%20detective%20silhouette%20in%20a%20rain-soaked%20neon%20city%20street%20at%20night%2C%20deep%20navy%20and%20orange%20palette%2C%20clean%20minimal%20gradient%20background%2C%20moody%20dramatic%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=mv-05&orientation=portrait",
    genres: ["犯罪", "悬疑"],
    region: "中国香港",
    year: 2026,
    subtitle: "中文字幕",
    quality: "超清",
    duration: "124分钟",
    episodes: 0,
    rating: 8.2,
    hot: 698000,
    updatedAt: "2026-10-10",
    description: "一场连绵雨季笼罩着整座城市，连环案件让警方束手无策。资深刑警与年轻搭档沿着一条几乎被忽略的线索追查，却在霓虹与雨水之间越陷越深。真相背后，是一段被刻意掩埋的往事。"
  },
  {
    id: "6",
    title: "山河故人谣",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20historical%20epic%20poster%20of%20majestic%20mountain%20ranges%20and%20an%20ancient%20warrior%20banner%20under%20dramatic%20sky%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20clean%20minimal%20gradient%20background%2C%20painterly%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=mv-06&orientation=portrait",
    genres: ["历史", "剧情"],
    region: "中国大陆",
    year: 2024,
    subtitle: "中文字幕",
    quality: "高清",
    duration: "150分钟",
    episodes: 0,
    rating: 8.6,
    hot: 634000,
    updatedAt: "2026-09-28",
    description: "跨越数十年的家国故事，讲述一代人在时代洪流中的选择与坚守。山河依旧，故人已远，唯有那些未曾说出口的牵挂，仍在岁月深处回荡。"
  },
  {
    id: "7",
    title: "代号·黎明",
    category: "movie",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20spy%20action%20poster%20of%20a%20secret%20agent%20in%20dark%20coat%20against%20a%20rising%20sun%20over%20a%20city%20skyline%2C%20deep%20navy%20and%20orange%20palette%2C%20clean%20minimal%20gradient%20background%2C%20dramatic%20backlight%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=mv-07&orientation=portrait",
    genres: ["动作", "谍战"],
    region: "中国大陆",
    year: 2026,
    subtitle: "中英字幕",
    quality: "蓝光",
    duration: "132分钟",
    episodes: 0,
    rating: 7.9,
    hot: 588000,
    updatedAt: "2026-10-08",
    description: "一名潜伏多年的情报人员，在任务临近收网时接到最后的指令。黎明之前最黑暗，他必须在身份暴露的边缘完成一项几乎不可能的任务。"
  },
  {
    id: "8",
    title: "都市微光",
    category: "tv",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20poster%20of%20young%20professionals%20on%20a%20rooftop%20overlooking%20glowing%20city%20lights%20at%20dusk%2C%20deep%20blue%20and%20warm%20orange%20tones%2C%20clean%20minimal%20gradient%20background%2C%20soft%20dramatic%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=tv-01&orientation=portrait",
    genres: ["都市", "剧情"],
    region: "中国大陆",
    year: 2026,
    subtitle: "中文字幕",
    quality: "超清",
    duration: "",
    episodes: 24,
    rating: 8.3,
    hot: 1120000,
    updatedAt: "2026-10-13",
    description: "四个在大城市打拼的年轻人，因为一间合租公寓而结缘。职场、理想、友情与爱情交织，他们在微光中互相照亮，也各自成长。"
  },
  {
    id: "9",
    title: "山河万里",
    category: "tv",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20costume%20epic%20poster%20of%20an%20ancient%20general%20on%20horseback%20before%20vast%20plains%20and%20distant%20mountains%2C%20deep%20navy%20and%20golden%20amber%20palette%2C%20clean%20minimal%20gradient%20background%2C%20dramatic%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=tv-02&orientation=portrait",
    genres: ["古装", "历史"],
    region: "中国大陆",
    year: 2025,
    subtitle: "中文字幕",
    quality: "蓝光",
    duration: "",
    episodes: 40,
    rating: 8.7,
    hot: 1024000,
    updatedAt: "2026-10-07",
    description: "乱世之中，一位少年将军从边关崛起，历经权谋与征伐，最终肩负起守护山河的重任。磅礴的战争场面与细腻的人物刻画交织出一幅宏大时代的画卷。"
  },
  {
    id: "10",
    title: "医者仁心",
    category: "tv",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20medical%20drama%20poster%20of%20a%20dedicated%20doctor%20in%20white%20coat%20in%20a%20softly%20lit%20hospital%20corridor%2C%20cool%20blue%20and%20warm%20orange%20tones%2C%20clean%20minimal%20gradient%20background%2C%20gentle%20dramatic%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=tv-03&orientation=portrait",
    genres: ["医疗", "剧情"],
    region: "中国大陆",
    year: 2026,
    subtitle: "中文字幕",
    quality: "超清",
    duration: "",
    episodes: 32,
    rating: 8.5,
    hot: 906000,
    updatedAt: "2026-10-12",
    description: "一群急诊科医生在生死一线间与时间赛跑。他们救治病患，也在职业与生活之间寻找平衡。每一个病例背后，都是关于生命与责任的故事。"
  },
  {
    id: "11",
    title: "岁月长歌",
    category: "tv",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20family%20saga%20poster%20of%20an%20old%20courtyard%20house%20with%20warm%20window%20light%20and%20drifting%20autumn%20leaves%2C%20deep%20blue%20dusk%20sky%20and%20amber%20glow%2C%20clean%20minimal%20gradient%20background%2C%20nostalgic%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=tv-04&orientation=portrait",
    genres: ["年代", "家庭"],
    region: "中国大陆",
    year: 2024,
    subtitle: "中文字幕",
    quality: "高清",
    duration: "",
    episodes: 36,
    rating: 8.0,
    hot: 672000,
    updatedAt: "2026-09-26",
    description: "一个普通家庭横跨三十年的悲欢离合，从老院子的四季更替到城市的日新月异。岁月如歌，唱的是平凡人最动人的坚持。"
  },
  {
    id: "12",
    title: "暗夜守望",
    category: "tv",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20detective%20mystery%20poster%20of%20a%20lone%20figure%20with%20a%20flashlight%20in%20a%20dark%20foggy%20forest%2C%20deep%20navy%20and%20orange%20palette%2C%20clean%20minimal%20gradient%20background%2C%20eerie%20dramatic%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=tv-05&orientation=portrait",
    genres: ["悬疑", "刑侦"],
    region: "中国大陆",
    year: 2026,
    subtitle: "中文字幕",
    quality: "超清",
    duration: "",
    episodes: 28,
    rating: 8.4,
    hot: 848000,
    updatedAt: "2026-10-06",
    description: "边境小镇接连发生失踪案，一位沉默的刑警在浓雾般的线索中抽丝剥茧。当所有证据指向同一个方向，他才意识到自己也被卷入了这场暗夜守望。"
  },
  {
    id: "13",
    title: "春江水暖",
    category: "tv",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20romance%20poster%20of%20two%20people%20walking%20along%20a%20riverside%20promenade%20in%20spring%20with%20cherry%20blossoms%2C%20soft%20blue%20and%20warm%20orange%20tones%2C%20clean%20minimal%20gradient%20background%2C%20tender%20lighting%2C%20high%20detail%20film%20poster%20art&width=600&height=900&seq=tv-06&orientation=portrait",
    genres: ["爱情", "都市"],
    region: "中国大陆",
    year: 2025,
    subtitle: "中文字幕",
    quality: "高清",
    duration: "",
    episodes: 26,
    rating: 7.7,
    hot: 594000,
    updatedAt: "2026-09-30",
    description: "江边的老书店里，两个曾经错过彼此的人再次相遇。春风化雨，往事如潮，他们决定给彼此、也给自己一次重新开始的机会。"
  },
  {
    id: "14",
    title: "星夜畅谈",
    category: "variety",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20variety%20show%20poster%20of%20a%20glowing%20modern%20talk%20show%20stage%20with%20microphones%20and%20audience%20lights%2C%20deep%20blue%20and%20bright%20orange%20palette%2C%20clean%20minimal%20gradient%20background%2C%20energetic%20lighting%2C%20high%20detail%20entertainment%20poster%20art&width=600&height=900&seq=vr-01&orientation=portrait",
    genres: ["脱口秀", "真人秀"],
    region: "中国大陆",
    year: 2026,
    subtitle: "中文字幕",
    quality: "超清",
    duration: "",
    episodes: 12,
    rating: 8.2,
    hot: 736000,
    updatedAt: "2026-10-13",
    description: "每期邀请不同领域的嘉宾，在星空下的舞台上畅谈人生、梦想与有趣的瞬间。轻松幽默的对话，温暖治愈的氛围，陪伴你的每一个夜晚。"
  },
  {
    id: "15",
    title: "美食环球记",
    category: "variety",
    cover: "https://readdy.ai/api/search-image?query=Bright%20variety%20show%20poster%20of%20a%20chef%20presenting%20colorful%20dishes%20on%20a%20wooden%20table%20with%20travel%20scenery%20behind%2C%20warm%20orange%20and%20deep%20blue%20palette%2C%20clean%20minimal%20gradient%20background%2C%20appetizing%20lighting%2C%20high%20detail%20entertainment%20poster%20art&width=600&height=900&seq=vr-02&orientation=portrait",
    genres: ["美食", "旅行"],
    region: "中国大陆",
    year: 2025,
    subtitle: "中文字幕",
    quality: "高清",
    duration: "",
    episodes: 16,
    rating: 8.6,
    hot: 812000,
    updatedAt: "2026-10-05",
    description: "跟着镜头走遍大江南北，寻找藏在街头巷尾的地道风味。每一道菜背后，都有一方水土与一段人情故事。舌尖上的旅程，从这里开始。"
  },
  {
    id: "16",
    title: "极限挑战营",
    category: "variety",
    cover: "https://readdy.ai/api/search-image?query=Energetic%20variety%20show%20poster%20of%20contestants%20racing%20through%20an%20outdoor%20obstacle%20course%20under%20bright%20sky%2C%20deep%20blue%20and%20vivid%20orange%20palette%2C%20clean%20minimal%20gradient%20background%2C%20dynamic%20lighting%2C%20high%20detail%20entertainment%20poster%20art&width=600&height=900&seq=vr-03&orientation=portrait",
    genres: ["真人秀", "竞技"],
    region: "中国大陆",
    year: 2026,
    subtitle: "中文字幕",
    quality: "超清",
    duration: "",
    episodes: 14,
    rating: 8.0,
    hot: 768000,
    updatedAt: "2026-10-11",
    description: "一群嘉宾在户外与室内展开层层挑战，智慧、体力与团队协作缺一不可。每一关都是新的考验，每一个笑容都是真实的热血。"
  },
  {
    id: "17",
    title: "音乐现场季",
    category: "variety",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20music%20show%20poster%20of%20a%20singer%20with%20a%20guitar%20under%20glowing%20stage%20spotlights%20and%20smoke%2C%20deep%20blue%20and%20warm%20orange%20palette%2C%20clean%20minimal%20gradient%20background%2C%20dramatic%20concert%20lighting%2C%20high%20detail%20entertainment%20poster%20art&width=600&height=900&seq=vr-04&orientation=portrait",
    genres: ["音乐", "现场"],
    region: "中国大陆",
    year: 2026,
    subtitle: "中英字幕",
    quality: "蓝光",
    duration: "",
    episodes: 10,
    rating: 8.8,
    hot: 902000,
    updatedAt: "2026-10-13",
    description: "顶尖歌手与人气乐队同台献唱，把最动人的旋律带到你的面前。沉浸式的现场体验，每一期都是一场属于耳朵的盛宴。"
  },
  {
    id: "18",
    title: "时尚大咖秀",
    category: "variety",
    cover: "https://readdy.ai/api/search-image?query=Glamorous%20fashion%20variety%20poster%20of%20models%20on%20a%20sleek%20runway%20with%20glowing%20lights%2C%20deep%20navy%20and%20orange%20gold%20palette%2C%20clean%20minimal%20gradient%20background%2C%20chic%20dramatic%20lighting%2C%20high%20detail%20entertainment%20poster%20art&width=600&height=900&seq=vr-05&orientation=portrait",
    genres: ["时尚", "真人秀"],
    region: "中国大陆",
    year: 2025,
    subtitle: "中文字幕",
    quality: "高清",
    duration: "",
    episodes: 12,
    rating: 7.9,
    hot: 528000,
    updatedAt: "2026-09-29",
    description: "聚焦时尚圈的台前幕后，记录设计师与模特们的灵感碰撞与高光时刻。T 台之上是光鲜亮丽，T 台之下是无数次的打磨与坚持。"
  }
];

export const banners = [
  {
    id: "b1",
    contentId: "8",
    title: "都市微光",
    subtitle: "都市 · 剧情 · 全 24 集",
    description: "四个在大城市打拼的年轻人，因为一间合租公寓而结缘，在微光中互相照亮，也各自成长。",
    image: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20key%20visual%20of%20a%20glittering%20modern%20city%20skyline%20at%20dusk%20with%20warm%20window%20lights%2C%20deep%20navy%20blue%20and%20orange%20color%20palette%2C%20dramatic%20sky%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20clean%20artful%20background&width=1920&height=900&seq=bn-01&orientation=landscape"
  },
  {
    id: "b2",
    contentId: "3",
    title: "深海迷航",
    subtitle: "冒险 · 科幻 · 中英字幕",
    description: "救援小队深入万米海沟，在黑暗的海底世界中面对未知生物与极端环境，寻回彼此也寻回敬畏。",
    image: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20key%20visual%20of%20a%20futuristic%20submarine%20descending%20into%20a%20glowing%20deep%20ocean%20trench%2C%20deep%20blue%20and%20teal%20palette%20with%20orange%20bioluminescent%20accents%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20clean%20artful%20background&width=1920&height=900&seq=bn-02&orientation=landscape"
  },
  {
    id: "b3",
    contentId: "9",
    title: "山河万里",
    subtitle: "古装 · 历史 · 全 40 集",
    description: "少年将军从边关崛起，历经权谋与征伐，肩负起守护山河的重任。",
    image: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20key%20visual%20of%20vast%20ancient%20plains%20with%20a%20lone%20warrior%20banner%20under%20dramatic%20clouds%20and%20golden%20light%2C%20deep%20navy%20and%20amber%20palette%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20clean%20artful%20background&width=1920&height=900&seq=bn-03&orientation=landscape"
  },
  {
    id: "b4",
    contentId: "16",
    title: "极限挑战营",
    subtitle: "真人秀 · 竞技 · 每周更新",
    description: "嘉宾在户外与室内展开层层挑战，智慧、体力与团队协作缺一不可。",
    image: "https://readdy.ai/api/search-image?query=Wide%20cinematic%20key%20visual%20of%20energetic%20contestants%20running%20across%20a%20bright%20outdoor%20obstacle%20course%2C%20deep%20blue%20sky%20and%20vivid%20orange%20accents%2C%20cinematic%20wide%20composition%2C%20high%20detail%2C%20clean%20artful%20background&width=1920&height=900&seq=bn-04&orientation=landscape"
  }
];